module.exports = __webpack_public_path__ + "img/settings1.2322e421.png";